import { Package, Clock } from "@phosphor-icons/react";

/** Toggles globais (afetam todos admins) — pedido novo e pedido atrasado. */
export default function PushTypeToggles({ cfg, savingCfg, saveCfg }) {
  return (
    <div className="border-t border-black/10 pt-4">
      <div className="text-[11px] uppercase tracking-wider text-zinc-500 mb-3">
        Tipos de alerta (aplicado a todos os administradores)
      </div>
      <div className="space-y-2">
        <ToggleRow
          testid="push-toggle-new-order"
          checked={cfg.notify_new_order}
          disabled={savingCfg}
          onChange={(v) => saveCfg({ notify_new_order: v })}
          icon={Package}
          label="Pedido novo"
          desc="Notifica quando o Bling envia um pedido novo pro sistema (via sync automático ou webhook)."
        />
        <ToggleRow
          testid="push-toggle-overdue"
          checked={cfg.notify_overdue}
          disabled={savingCfg}
          onChange={(v) => saveCfg({ notify_overdue: v })}
          icon={Clock}
          label="Pedido atrasado"
          desc="Notifica na 1ª vez em que a data de entrega é ultrapassada. Não repete pro mesmo pedido."
        />
      </div>
    </div>
  );
}

function ToggleRow({ testid, checked, disabled, onChange, icon: Icon, label, desc }) {
  return (
    <label className="flex items-start gap-3 cursor-pointer p-2 hover:bg-zinc-50 rounded" data-testid={testid}>
      <input
        type="checkbox"
        className="mt-1"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <div className="flex-1">
        <div className="flex items-center gap-2 font-semibold text-sm">
          <Icon size={16} weight="bold" /> {label}
        </div>
        <div className="text-xs text-zinc-500">{desc}</div>
      </div>
    </label>
  );
}
